/**
 * Insert text at a textarea selection — the pure half of PatientSidebar.insertAtCursor.
 * Keep IMPORT-FREE: cypress/node-tests/text-insert.test.js executes this exact file.
 * Positions and the returned caret are UTF-16 code-unit offsets, exactly what
 * HTMLTextAreaElement.selectionStart/setSelectionRange use (an emoji is two units).
 */
export function spliceAtCursor(text, start, end, insert) {
  const t = String(text == null ? '' : text);
  const ins = String(insert == null ? '' : insert);
  const len = t.length;
  let s = Number.isInteger(start) ? Math.min(Math.max(start, 0), len) : len;
  let e = Number.isInteger(end) ? Math.min(Math.max(end, 0), len) : s;
  if (e < s) { const tmp = s; s = e; e = tmp; }
  return { text: t.substring(0, s) + ins + t.substring(e), caret: s + ins.length };
}

export default { spliceAtCursor };
